function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 6.95,
    height: 4.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.6683333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 2.005
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4.01,
    width: 6.95,
    height: 14.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 11.075
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.13,
    width: 6.95,
    height: 24.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 30.325
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.53,
    width: 6.95,
    height: 33.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3900000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 59.31
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76.09,
    width: 6.95,
    height: 38.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.86875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 95.44
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.79,
    width: 6.95,
    height: 39.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9928571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 134.315
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 153.84,
    width: 6.95,
    height: 46.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 177.065
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 200.29,
    width: 6.95,
    height: 49.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7722222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 224.845
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 249.4,
    width: 6.95,
    height: 58.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 278.815
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.23,
    width: 6.95,
    height: 59.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.6950000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 338.17
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 368.11,
    width: 6.95,
    height: 60.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 398.165
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 428.23,
    width: 6.95,
    height: 62.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 459.595
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.96,
    width: 6.95,
    height: 67.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7722222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 524.6999999999999
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 558.44,
    width: 6.95,
    height: 69.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3900000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 593.2800000000001
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 628.12,
    width: 6.95,
    height: 71.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.475,
    y: 664.06
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 0,
    width: 19.5,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.7,
    y: 19.615
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.45,
    y: 0,
    width: 19.5,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.2,
    y: 19.615
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.95,
    y: 0,
    width: 20.64,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.27,
    y: 19.615
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.6,
    y: 0,
    width: 21.65,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 77.425,
    y: 19.615
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.24,
    y: 0,
    width: 23.2,
    height: 39.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.83999999999999,
    y: 19.615
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.44,
    y: 0,
    width: 23.64,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.25999999999999,
    y: 19.615
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.09,
    y: 0,
    width: 25.61,
    height: 39.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2683333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.895,
    y: 19.615
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 0,
    width: 26.42,
    height: 39.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.284000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.9,
    y: 19.615
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.11,
    y: 0,
    width: 26.8,
    height: 39.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.51000000000002,
    y: 19.615
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.91,
    y: 0,
    width: 33.75,
    height: 39.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.21875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.785,
    y: 19.615
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.67,
    y: 0,
    width: 34.15,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7944444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.745,
    y: 19.615
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.81,
    y: 0,
    width: 41.52,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.358888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.57,
    y: 19.615
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.33,
    y: 0,
    width: 51.13,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.538333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.895,
    y: 19.615
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.46,
    y: 0,
    width: 60.09,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.538333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.505,
    y: 19.615
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.56,
    y: 0,
    width: 63.83,
    height: 39.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.475,
    y: 19.615
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.38,
    y: 0,
    width: 63.99,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.538333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.375,
    y: 19.615
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.38,
    y: 0,
    width: 68.77,
    height: 39.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.765,
    y: 19.615
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.15,
    y: 0,
    width: 68.85,
    height: 39.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.90375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.5749999999999,
    y: 19.615
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 39.23,
    width: 72.19,
    height: 46.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1233333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 62.655
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 86.08,
    width: 72.19,
    height: 47.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.466
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 109.745
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 133.41,
    width: 72.19,
    height: 50.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 158.62
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 183.83,
    width: 72.19,
    height: 53.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 210.425
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 237.02,
    width: 72.19,
    height: 63.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.338
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 268.71000000000004
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 300.4,
    width: 72.19,
    height: 63.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 332.31
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 364.22,
    width: 72.19,
    height: 69.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 398.795
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 433.38,
    width: 72.19,
    height: 87.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5627272727272725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 477.105
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 520.83,
    width: 72.19,
    height: 87.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.437999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 564.71
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95,
    y: 608.59,
    width: 72.19,
    height: 91.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.031666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.045,
    y: 654.2950000000001
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.14,
    y: 39.23,
    width: 71.43,
    height: 96.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.855,
    y: 87.60499999999999
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.57,
    y: 39.23,
    width: 77.15,
    height: 96.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.934615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.14499999999998,
    y: 87.60499999999999
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.72,
    y: 39.23,
    width: 97.08,
    height: 96.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.26,
    y: 87.60499999999999
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.8,
    y: 39.23,
    width: 100.04,
    height: 96.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.821428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.82,
    y: 87.60499999999999
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.84,
    y: 39.23,
    width: 127.82,
    height: 96.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.75,
    y: 87.60499999999999
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.66,
    y: 39.23,
    width: 147.34,
    height: 96.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.910714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.3299999999999,
    y: 87.60499999999999
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.14,
    y: 135.99,
    width: 112.75,
    height: 128.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.527777777777779
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.515,
    y: 199.995
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.14,
    y: 264,
    width: 112.75,
    height: 141.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.395833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.515,
    y: 334.855
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.14,
    y: 405.71,
    width: 112.75,
    height: 141.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.673076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.515,
    y: 476.65999999999997
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.14,
    y: 547.61,
    width: 112.75,
    height: 152.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.515,
    y: 623.8050000000001
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.89,
    y: 135.99,
    width: 139.53,
    height: 181.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.93285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.655,
    y: 226.985
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.42,
    y: 135.99,
    width: 151.66,
    height: 181.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.787272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.25,
    y: 226.985
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.08,
    y: 135.99,
    width: 216.92,
    height: 181.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.221111111111114
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.54,
    y: 226.985
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.89,
    y: 317.97,
    width: 107.19,
    height: 382.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.48499999999999,
    y: 508.985
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.08,
    y: 317.97,
    width: 400.92,
    height: 382.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.53999999999996,
    y: 508.985
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1976);
export default __webpack_public_path__ + "static/media/1976.0f811ef2faee5750e6498927b81fe742.svg";
export { ForwardRef as ReactComponent };